import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestBannerList = () => {
  const result = apiClient.get(
    '/user/banner',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestBannerList2 = () => {
  const result = apiClient.get(
    '/user/banner',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestBannerList,
  requestBannerList2,
};
